module.exports = __webpack_public_path__ + "media/images/logo/dhl-6d2f20a797dec39a94a1a27536947941.gif";